import { render, staticRenderFns } from "./EventPanel.vue?vue&type=template&id=62380416&scoped=true"
import script from "./EventPanel.vue?vue&type=script&lang=js"
export * from "./EventPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62380416",
  null
  
)

export default component.exports